
import { ImportPage, ExportPage } from "./importExport";
import { EditVersionPage } from "./creation";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { Button } from "antd";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useParams } from "react-router-dom";
import { RESOURCE_TYPE_VERSIONS, NAV_TO_VERSION_LIST } from '@/resources-def/versionSettings-comp';

export const VersionActionPage = ({ goto }) => {

  const { action, id } = useParams();
  const navigate = useResourceNavigate();
  const onCancel = (e) => {
    e.preventDefault();
    navigate({ resource:goto, action: "list" });
  };

  if (action == "import") {
    return (<div><TopBreadcrumb  disableId="true"/><ImportPage id={id} goto={goto} /></div>);
  } if (action == "export") {
    return (<div><TopBreadcrumb /><ExportPage id={id} goto={goto}/></div>);
  } else if (action === "edit") {
    return <EditVersionPage id={id} goto={goto}/>;
  } 
};
